import React from "react";

const Footer = () => {
  return (
    <>
      <footer className='w-full mt-8 text-center py-4 text-gray-300'>
        Made With 💝 by Muhammad Anas Soomro (me).
      </footer>
    </>
  );
};

export default Footer;
